import { useRef, useEffect, useState } from 'react';
import {
  deletedDuplicateByAuthor,
  getActiveState,
} from '../helpers/titreHelper';
import { useGetParams } from './useGetParams';
import { useInterval } from './useInterval';
import { v4 as uuidv4 } from 'uuid';
import useLocalStorage from './useLocalStorage';
import { loadImages } from '../helpers/preload';

export const useCarousel = (stagesS) => {
  const { stageSlowS, stageFastS, stageWinnerS, stageСleaningS } = stagesS;

  const {
    user,
    carousel = '1',
    repeatCount,
    startFrom,
    speedFast,
    speedSlow,
    amount,
    randomOrder,
  } = useGetParams();
  const [currentState, setCurrentState] = useState(null);
  const [isVisible, setIsVisible] = useState(null);
  const [showedMessages, setShowedMessages] = useState([]);

  const lastMessageIdRef = useRef(0);
  const nextMessageIndexRef = useRef(-1);
  const messagesRef = useRef([]);
  const currentMessageRef = useRef(null);
  const winnerMessageRef = useRef(null);

  const [winIds, setWinIds] = useLocalStorage('winIds', []);

  // время затраченное на появления одного сообщения в ms
  const [speed, setSpeed] = useState(speedSlow);

  const iactiveIdRef = useRef('');

  const protocol = window?.location.protocol || 'https:';

  function shuffle(array) {
    for (let i = array.length - 1; i > 0; i--) {
      let j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
  }

  // создание участников розыгрыша
  if (amount && !messagesRef.current.length) {
    let arr = [];
    for (let index = 1; index <= Number(amount); index++) {
      let num = '';
      let countChar = amount.length - index.toString().length;

      for (let index = 0; index < countChar; index++) {
        num += '0';
      }

      let newEl = {
        id: index.toString(),
        message: {
          content: `№ ${num}${index}`,
          id: `msg-${index}`,
        },
      };
      arr.push(newEl);
    }
    // случайный порядок
    if (randomOrder === '1') {
      shuffle(arr);
    }

    messagesRef.current = arr.filter((msg) => !winIds.includes(msg.id));
  }

  const getBroadcastInfo = async () => {
    try {
      if (!user) {
        return;
      }

      const response = await fetch(
        `${protocol}//api.stream.iactive.pro/titreInfo?user=${user}&from=${lastMessageIdRef.current}&type=1`
      );
      const data = await response.json();
      if (!data) return;
      let { messagesList, deletedMessagesIdList, visibility, iactiveId } = data;

      // При запуске следующей трансляции обновление
      if (iactiveIdRef.current !== iactiveId) {
        lastMessageIdRef.current = 0;
        nextMessageIndexRef.current = -1;
        setShowedMessages([]);
        messagesRef.current = [];
        iactiveIdRef.current = iactiveId;
      }

      // Определяем видимость титра
      if (!visibility && visibility !== isVisible) {
        setIsVisible(false);
        return;
      } else if (visibility && visibility !== isVisible) {
        setIsVisible(true);
      }

      // Определяем состояние (S1, S2 ...)
      if (
        data?.statusList[0]?.state &&
        getActiveState(data?.statusList[0]?.state) !== currentState
      ) {
        const curState = getActiveState(data?.statusList[0].state);

        let prevState = currentState;

        if (
          prevState === stageWinnerS &&
          [stageSlowS, stageFastS].includes(curState)
        ) {
          setSpeed(speedSlow + 500);
          setTimeout(() => {
            setShowedMessages(
              showedMessages.filter((item) => !winIds.includes(item.id))
            );
          }, 100);

          setTimeout(() => {
            setSpeed(curState === stageSlowS ? speedSlow : speedFast);
          }, speedSlow + 500);
        }
        setCurrentState(curState);

        if (curState === stageSlowS && speed !== speedSlow) {
          setSpeed(speedSlow);
        } else if (curState === stageFastS && speed !== speedFast) {
          setSpeed(speedFast);
        }

        if (curState === stageWinnerS) {
          if (
            winnerMessageRef.current &&
            !winIds.includes(winnerMessageRef.current.id)
          ) {
            setWinIds([...winIds, winnerMessageRef.current.id]);
            messagesRef.current = messagesRef.current.filter(
              (msg) =>
                !winIds.includes(msg.id) &&
                msg.id !== winnerMessageRef.current.id
            );
          }
        }

        if (curState === stageСleaningS) {
          setWinIds([]);
          setShowedMessages([]);
          nextMessageIndexRef.current = -1;
          messagesRef.current = [];
          lastMessageIdRef.current = 0;
          return;
        }
      }

      // Удаляем сообщения по команде пользователя
      if (
        showedMessages.some((item) =>
          deletedMessagesIdList.includes(Number(item.id))
        )
      ) {
        setShowedMessages(
          showedMessages.filter(
            (item) => !deletedMessagesIdList.includes(Number(item.id))
          )
        );
      }

      // если список сообщений не пустой
      if (Array.isArray(messagesList) && messagesList.length === 0) {
        // если имеются в списке сообщений удаленные
        if (
          messagesRef.current.some((el) =>
            deletedMessagesIdList.includes(+el.id)
          )
        ) {
          const newState = messagesRef.current.filter(
            (el) => !deletedMessagesIdList.includes(+el.id)
          );

          for (let i = 0; i < messagesRef.current.length; i++) {
            if (
              !newState.find(
                (el) =>
                  nextMessageIndexRef.current &&
                  el.id === messagesRef.current[nextMessageIndexRef.current]?.id
              )
            ) {
              if (
                messagesRef.current[nextMessageIndexRef.current] ===
                messagesRef.current[messagesRef.current.length - 1]
              ) {
                nextMessageIndexRef.current--;
                if (nextMessageIndexRef.current < 0)
                  nextMessageIndexRef.current = 0;
              }
            }
            if (
              i < nextMessageIndexRef.current &&
              !newState.find((el) => el.id === messagesRef.current[i].id)
            ) {
              nextMessageIndexRef.current--;
              if (nextMessageIndexRef.current < 0)
                nextMessageIndexRef.current = 0;
            }
          }
          messagesRef.current = newState;
        }

        //запоминаем id последнего сообщения, для дальнейших запросов и обнуляем при переключении интерактивов
        if (iactiveIdRef.current && iactiveIdRef.current !== iactiveId) {
          lastMessageIdRef.current = 0;
          iactiveIdRef.current = iactiveId;
          return;
        } else {
          iactiveIdRef.current = iactiveId;
          lastMessageIdRef.current =
            messagesList[0]?.id || lastMessageIdRef.current;
        }

        return;
      }

      // Удаляем сообщения, если они не содержат текста или картинки.
      messagesList = messagesList.filter(
        (el) =>
          !(
            Array.isArray(el.message.attachments) &&
            el.message.attachments.length > 0 &&
            typeof el.message.attachments[0] === 'object' &&
            el.message.attachments[0].type === 'audio_msg' &&
            el.message.content === ''
          )
      );

      //запоминаем id последнего сообщения, для дальнейших запросов и обнуляем при переключении интерактивов
      if (iactiveIdRef.current && iactiveIdRef.current !== iactiveId) {
        lastMessageIdRef.current = 0;
        iactiveIdRef.current = iactiveId;
        return;
      } else {
        iactiveIdRef.current = iactiveId;
        lastMessageIdRef.current =
          messagesList[0]?.id || lastMessageIdRef.current;
      }

      let result = [...messagesRef.current, ...messagesList.reverse()];

      // предзагрузка аватарок
      let urls = result?.map((m) => m.message.image)?.filter((u) => u);
      if (urls && urls.length !== 0) {
        loadImages(urls);
      }

      result = deletedDuplicateByAuthor(result, nextMessageIndexRef);

      if (!amount) {
        messagesRef.current = result
          .filter((msg) => !winIds.includes(msg.id))
          .slice(-repeatCount);
      }

      // messagesRef.current = result;
    } catch (error) {
      console.error(error);
    }
  };

  const iterateIndex = (array) => {
    if (carousel === '1') {
      if (!array.length) {
        nextMessageIndexRef.current = -1;
        return;
      }
      if (nextMessageIndexRef.current < array.length - 1) {
        nextMessageIndexRef.current++;
      } else {
        if (messagesRef.current.length >= startFrom) {
          messagesRef.current = messagesRef.current.slice(-repeatCount);

          nextMessageIndexRef.current = 0;
        }
      }
    } else {
      if (nextMessageIndexRef.current < messagesRef.current.length - 1)
        nextMessageIndexRef.current++;
      else {
        nextMessageIndexRef.current = messagesRef.current.length - 1;
      }
    }
  };

  const updateShowedMessages = (newMessages) => {
    if (newMessages && messagesRef.current.length >= startFrom) {
      currentMessageRef.current = newMessages;
      const currentMessageWithUUID = { ...newMessages, UUID: uuidv4() };

      const newMessagesArr = [currentMessageWithUUID, ...showedMessages].slice(
        0,
        4
      );
      winnerMessageRef.current = newMessagesArr[1];
      setShowedMessages(newMessagesArr);
    }
  };

  useEffect(() => {
    getBroadcastInfo().then(() => {
      if (messagesRef.current && messagesRef.current.length > 0) {
        iterateIndex(messagesRef.current);
        updateShowedMessages(messagesRef.current[nextMessageIndexRef.current]);
      }
    });
  }, []);

  // Выбор сообщения для показа
  useInterval(
    () => {
      iterateIndex(messagesRef.current);
      if (
        !messagesRef.current[nextMessageIndexRef.current]?.id ||
        (showedMessages.some(
          (el) => el.id === messagesRef.current[nextMessageIndexRef.current].id
        ) &&
          carousel === '0')
      ) {
        return;
      } else if (carousel === '1' && messagesRef.current.length < startFrom) {
        return;
      } else {
        updateShowedMessages(messagesRef.current[nextMessageIndexRef.current]);
      }
    },
    currentState === stageSlowS || currentState === stageFastS ? speed : null
  );

  // Получение информации о титре
  useInterval(getBroadcastInfo, 2000);

  return {
    currentState,
    isVisible,
    showedMessages,
    messagesRef: messagesRef.current,
    winnerMessage: winnerMessageRef.current,
    speed,
    setSpeed,
  };
};
